export const calendarData = [
  {
    title: 'Consultation - Mike Fisherman',

    borderColor: 'transparent',
    start: '2022-09-27',
    end: '2022-09-29',
    backgroundColor: '#7551FF',
    className: 'info',
  },

  {
    title: 'Consultation - Alex Johnson',

    borderColor: 'transparent',
    start: '2022-10-06',
    end: '2022-10-08',
    backgroundColor: '#01B574',
    className: 'success',
  },

  {
    title: 'Consultation - David Smith',

    borderColor: 'transparent',
    start: '2022-10-10',
    end: '2022-10-12',
    backgroundColor: '#FFB547',
    className: 'warning',
  },

  {
    title: 'Consultation - Danielle Johnson',

    borderColor: 'transparent',
    start: '2022-10-21',
    end: '2022-10-23',
    backgroundColor: '#7551FF',
    className: 'error',
  },
];
